import { ReactNode } from "react";

import type { DrawingToolName } from "../model";
import {
  LineIcon,
  RayLineIcon,
  TrendLineIcon,
  ParallelChannelIcon,
  FibonacciIcon,
  RectangleIcon,
} from "./icons";

import styles from "./styles/SelectDrawingTool.module.css";

export interface ToolConfig {
  name: DrawingToolName;
  label: string;
  icon: ReactNode;
}

export const TOOLS: ToolConfig[] = [
  {
    name: "horizontalLine",
    label: "Horizontal Line",
    icon: <LineIcon direction="horizontal" className={styles.itemIcon} />,
  },
  {
    name: "verticalLine",
    label: "Vertical Line",
    icon: <LineIcon direction="vertical" className={styles.itemIcon} />,
  },
  {
    name: "rayLine",
    label: "Ray Line",
    icon: <RayLineIcon className={styles.itemIcon} />,
  },
  {
    name: "fibonacciRetracement",
    label: "Fibonacci Retracement",
    icon: <FibonacciIcon className={styles.itemIcon} />,
  },
  {
    name: "trendLine",
    label: "Trend Line",
    icon: <TrendLineIcon className={styles.itemIcon} />,
  },
  {
    name: "parallelChannel",
    label: "Parallel Channel",
    icon: <ParallelChannelIcon className={styles.itemIcon} />,
  },
  {
    name: "rectangle",
    label: "Rectangle",
    icon: <RectangleIcon className={styles.itemIcon} />,
  },
];
